import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { from } from 'apollo-link'
import { onError } from 'apollo-link-error'
import schema from '../fragmentTypes.json'

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema
})

// Create error link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    })
  }
  if (networkError) {
    console.error(`[Network error]: ${networkError.message}`)

    // For static site generation, continue despite errors
    if (process.static && process.client === false) {
      console.warn('Continuing static generation despite GraphQL error')
    }
  }
})

export default function (context) {
  const backendUrl = context.$config.backendUrl

  if (!backendUrl) {
    console.error('Backend URL is not configured. Check your environment variables.')
    throw new Error('Backend URL is required for Apollo client')
  }

  console.log('Apollo client connecting to:', `${backendUrl}/graphql`)

  // Create HTTP link
  const httpLink = createHttpLink({
    uri: `${backendUrl}/graphql`,
    timeout: 30000,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    // Add fetch policy to handle network errors better
    fetchOptions: {
      mode: 'cors',
    }
  })

  return {
    link: from([errorLink, httpLink]),
    cache: new InMemoryCache({ fragmentMatcher }),
    defaultOptions: {
      query: {
        fetchPolicy: 'cache-first',
        errorPolicy: 'all'
      },
      watchQuery: {
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
      }
    }
  }
}
